import { render, staticRenderFns } from "./TemplateInquiry.vue?vue&type=template&id=5881afa0&scoped=true"
import script from "./TemplateInquiry.vue?vue&type=script&lang=js"
export * from "./TemplateInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5881afa0",
  null
  
)

export default component.exports